<template>
	<div class="stepper">
		<template v-for="(s, i) in steps">
			<span v-if="i" :key="'sep' + i" class="sep">›</span>
			<span :key="'st' + i" class="st" :class="{ on: i + 1 === current, done: i + 1 < current }"><span class="n"><i v-if="i + 1 < current" class="fa-solid fa-check"></i><template v-else>{{ i + 1 }}</template></span>{{ s }}</span>
		</template>
	</div>
</template>

<script>
export default {
	name: 'PeStepper',
	props: {
		steps: { type: Array, default: () => [] }, // ['Who', 'Build', 'Send']
		current: { type: Number, default: 1 }, // 1-based
	},
}
</script>
